module.exports = __webpack_public_path__ + "media/images/cuk-dark-3fdbc21ea808b94f89eacadf2afb6ec9.png";